module.exports = __webpack_public_path__ + "img/feature-11-2.579f9b8a.png";